import { render, staticRenderFns } from "./UserWelcomeComponent.vue?vue&type=template&id=60fb60fe"
import script from "./UserWelcomeComponent.vue?vue&type=script&lang=js"
export * from "./UserWelcomeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports